<cw-dialog
  [attr.data-vef]="'dialog-container'"
  customShadowCss
  [styles]="dialogStyles()"
  [open]="dialog()?.open"
  [dialogTitle]="dialog()?.config?.title | translate"
  action-button-variant="filled"
  secondary-button-color="secondary"
  secondary-button-variant="outlined"
  (dialogClosed)="clickOutside()"
>
  @if (dialog()?.open && dialogComponent()) {
    <ng-container *ngComponentOutlet="dialogComponent(); inputs: { dialog: dialog() }" />
  }

  <!-- Content -->
  @if (dialog()?.config?.content) {
    {{ dialog().config.content | translate }}
  }

  <div slot="footer">
    <div class="inner">
      @if (dialog()?.config?.secondaryLabel) {
        <cw-button (click)="dialog()?.confirm.next(false)" button-color="secondary" variant="outlined">{{
          dialog()?.config?.secondaryLabel | translate
        }}</cw-button>
      }
      @if (dialog()?.config?.actionLabel) {
        <cw-button (click)="dialog()?.confirm.next(true)" [buttonColor]="dialog()?.actionBtnColor || 'accent'">{{
          dialog()?.config?.actionLabel | translate
        }}</cw-button>
      }
    </div>
  </div>
</cw-dialog>
